import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const REQUEST_PROPERTY_INCOMES = 'REQUEST_PROPERTY_INCOMES'
export const RECEIVE_PROPERTY_INCOMES = 'RECEIVE_PROPERTY_INCOMES'
export const SAVE_PROPERTY_INCOME = 'SAVE_PROPERTY_INCOME'

export const requestPropertyIncomes = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_PROPERTY_INCOMES, data: { taxReturnId } })

    axios
        .get(`/propertyincomes?taxReturnId=${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || []
            dispatch(
                receivePropertyIncomes({
                    fetchSuccessful: true,
                    items: responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receivePropertyIncomes({ fetchSuccessful: true }))
                return
            }

            dispatch(receivePropertyIncomes({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receivePropertyIncomes = (data) => ({ type: RECEIVE_PROPERTY_INCOMES, data })

export const savePropertyIncome = (data) => (dispatch) => {
    dispatch({ type: SAVE_PROPERTY_INCOME, data })

    const { id } = data

    return axios
        .put(`/propertyincomes/${id}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receivePropertyIncomes({
                    items: [responseData],
                })
            )
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject()
        })
}

export const updateAndSavePropertyIncome = (data) => (dispatch) => {
    dispatch(receivePropertyIncomes({ items: [data] }))
    return dispatch(savePropertyIncome(data)).catch(() => {})
}
